<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  function handleImpressumClick() {
    dispatch('toggleImpressum');
  }

  function handleDatenschutzClick() {
    dispatch('toggleDatenschutz');
  }

  function handleLicensesClick() {
    dispatch('toggleLicenses');
  }
</script>

<footer class="mt-2 pt-4">
  <div class="flex flex-wrap justify-center gap-3 md:gap-4">
    <button
      on:click={handleImpressumClick}
      class="px-2 py-1 text-xs text-custom-secondary dark:text-white/50 hover:text-custom dark:hover:text-white/80 transition-colors duration-200 cursor-pointer"
    >
      {$_(`footer.impressum`)}
    </button>
    <span class="text-slate-400 dark:text-white/30 text-xs">•</span>
    <button
      on:click={handleDatenschutzClick}
      class="px-2 py-1 text-xs text-custom-secondary dark:text-white/50 hover:text-custom dark:hover:text-white/80 transition-colors duration-200 cursor-pointer"
    >
      {$_(`footer.datenschutz`)}
    </button>
    <span class="text-slate-400 dark:text-white/30 text-xs">•</span>
    <button
      on:click={handleLicensesClick}
      class="px-2 py-1 text-xs text-custom-secondary dark:text-white/50 hover:text-custom dark:hover:text-white/80 transition-colors duration-200 cursor-pointer"
    >
      {$_(`footer.licenses`)}
    </button>
  </div>
</footer>
